// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-body{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 80vh;
}
.login-container{
    padding: 20px 30px;
    text-align: center;
    color: rgb(255, 68, 68);
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.4);
    border-radius: 20px;
}
.login-container button{
    color: white;
    background-color: rgb(255, 68, 68);
    border: none;
    padding: 10px 16px;
    border-radius: 20px;
    cursor: pointer;
    transition: opacity 0.2s ease;
}
.login-container button:hover{
    opacity: 0.9;
}`, "",{"version":3,"sources":["webpack://./src/styles/Login.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;IACvB,0CAA0C;IAC1C,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,kCAAkC;IAClC,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,6BAA6B;AACjC;AACA;IACI,YAAY;AAChB","sourcesContent":[".login-body{\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    height: 80vh;\r\n}\r\n.login-container{\r\n    padding: 20px 30px;\r\n    text-align: center;\r\n    color: rgb(255, 68, 68);\r\n    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.4);\r\n    border-radius: 20px;\r\n}\r\n.login-container button{\r\n    color: white;\r\n    background-color: rgb(255, 68, 68);\r\n    border: none;\r\n    padding: 10px 16px;\r\n    border-radius: 20px;\r\n    cursor: pointer;\r\n    transition: opacity 0.2s ease;\r\n}\r\n.login-container button:hover{\r\n    opacity: 0.9;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
